// extracted by mini-css-extract-plugin
export default {"body":"menu_body__f+FMG","main":"menu_main__B8IFR","footer":"menu_footer__s0vzh"};